import { ArrowLeftCircle, Check } from 'lucide-react'
import L from 'leaflet'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet/dist/leaflet.css'
import { useEffect, useRef, useState } from 'react'
import { ListGroup, Tab, Tabs } from 'react-bootstrap'
import Select from 'react-select'
import {
  FeatureGroup,
  ImageOverlay,
  MapContainer,
  Rectangle
} from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'
import ModalMapEditor from '../../../components/modal/mapeditor/ModalMapEditor'
import ModalMapVas from '../../../components/modal/mapeditor/ModalMapVas'
import ModalUpdateMapEditor from '../../../components/modal/mapeditor/ModalUpdateMapEditor'
import api from '../../../config/AxiosInstance'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'

function MapEditorDetail({
  data,
  step,
  onHandleResetDetailData,
  onHandleStep
}) {
  const [rectangleBounds, setRectangleBounds] = useState([])
  const [showModalAdd, setShowModalAdd] = useState(false)
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const [showModalVas, setShowModalVas] = useState(false)
  const [file, setFile] = useState(null)
  const [selectLevel, setSelectLevel] = useState(null)
  const [showDataMap, setShowDataMap] = useState(0)
  const [dataMapEditor, setDataMapEditor] = useState([])
  const [loadingMapVas, setLoadingMapVas] = useState(false)
  const [activeTab, setActiveTab] = useState('top-view')
  const [doubleRackSlots, setDoubleRackSlots] = useState([])
  const resetDetailData = () => onHandleResetDetailData()
  const hiddenFileInput = useRef(null)
  const selectLevelRef = useRef(selectLevel)

  const arrLevel = [
    '1',
    'ground',
    'staging-area',
    'vas',
    'vas_pharma',
    'transit_vas',
    'transit_vas_pharma'
  ]

  const _created = (e) => {
    const { layerType, layer } = e
    if (layerType === 'rectangle') {
      const bounds = layer.getBounds()
      const southWest = bounds.getSouthWest()
      const northEast = bounds.getNorthEast()
      const southEast = bounds.getSouthEast()
      const northWest = bounds.getNorthWest()
      const coordinates = [
        [southWest.lat, southWest.lng],
        [northEast.lat, northEast.lng],
        [southEast.lat, southEast.lng],
        [northWest.lat, northWest.lng]
      ]
      setRectangleBounds(coordinates)
    }

    if (
      ['vas', 'vas_pharma', 'transit_vas', 'transit_vas_pharma'].includes(
        selectLevelRef.current
      )
    ) {
      setShowModalVas(true)
    } else {
      setShowModalAdd(true)
    }
  }

  const _deleted = (e) => setRectangleBounds([])
  const _edited = (e) => {
    console.log(e)
  }

  const handleClick = (event) => {
    hiddenFileInput.current.click()
  }

  const handleChange = async (event) => {
    try {
      const formData = new FormData()
      formData.append('warehouse_id', data.id)
      formData.append('map_image', event.target.files[0])
      await api.postForm('settings/map', formData)
      setFile(URL.createObjectURL(event.target.files[0]))
      Common.showPopUpSuccessMessage('Upload map successfully')
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const handleSelectLevel = (e) => {
    setSelectLevel(e.match(/(\d+)/) ? Number(e) : e)
    arrLevel.filter((level) => level === e).length > 0
      ? document
          .querySelector('.leaflet-draw.leaflet-control')
          ?.classList.remove('d-none')
      : document
          .querySelector('.leaflet-draw.leaflet-control')
          ?.classList.add('d-none')
  }

  const listMapEditor = async (level, warehouse_id) => {
    try {
      let type = ''
      let levelLabel = ''
      if (Number(level)) {
        type = 'rack'
        levelLabel = level
      } else if (
        [
          'ground',
          'vas',
          'vas_pharma',
          'transit_vas',
          'transit_vas_pharma'
        ].includes(level)
      ) {
        type = level
        levelLabel = level === 'ground' ? 'ground' : 1
      } else if (level === 'staging-area') {
        type = 'staging'
        levelLabel = level
      }
      const values = {
        level: levelLabel,
        warehouse_id,
        type
      }
      const res = await api.post(`settings/map/editor/slot/list`, values)
      setDataMapEditor(res.data.data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'

      Common.showPopUpErrorMessage(errMsg)
    }
  }

  function handleRectangleClick(rectangleId) {
    if (
      step === 1 &&
      !['vas', 'vas_pharma', 'transit_vas', 'transit_vas_pharma'].includes(
        selectLevel
      )
    ) {
      setShowModalUpdate(true)
      setShowDataMap(rectangleId)
    }
    if (
      step === 1 &&
      ['vas', 'vas_pharma', 'transit_vas', 'transit_vas_pharma'].includes(
        selectLevel
      )
    ) {
      setShowModalVas(true)
      setShowDataMap(rectangleId)
    }
    return
  }

  const handleSubmitMapVas = async () => {
    try {
      setLoadingMapVas(true)
      const res = await api.post('settings/map/editor/slot-area/add', {
        warehouse_id: data.id,
        area_type: selectLevel,
        coordinates: rectangleBounds
      })
      if (res.data.success) {
        Common.showPopUpSuccessMessage(res.data.message)
        document
          .querySelector(".leaflet-interactive[stroke='#3388ff']")
          ?.remove()
        setShowModalVas(false)
        listMapEditor(selectLevel, data.id)
      }
    } catch (error) {
      const err = error.response.data.errors.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingMapVas(false)
    }
  }

  useEffect(
    function () {
      if (data) {
        setFile(data.warehouse_map)
      }
    },
    [data]
  )

  const [selectedRackView, setSelectedRackView] = useState('')

  const fetchDoubleRackSlots = async (warehouseId) => {
    try {
      const res = await api.get(
        `settings/map/editor/rack/double/slots/${warehouseId}`
      )
      if (res.data.success) {
        const cleanedData = res.data.data.map((slot) => ({
          ...slot,
          rack_name: slot.rack_name ? slot.rack_name.trim() : slot.rack_name
        }))
        setDoubleRackSlots(cleanedData)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(
    function () {
      if (data && selectLevel) {
        listMapEditor(selectLevel, data.id)
        selectLevelRef.current = selectLevel
      }
    },
    [selectLevel, data]
  )

  useEffect(() => {
    if (data?.id) {
      fetchDoubleRackSlots(data.id)
    }
  }, [data])

  const renderSideView = () => {
    if (!doubleRackSlots || doubleRackSlots.length === 0)
      return <p className="text-center mt-4">No double racks found.</p>

    const groupedByRack = doubleRackSlots.reduce((acc, slot) => {
      if (!acc[slot.rack_name]) acc[slot.rack_name] = []
      acc[slot.rack_name].push(slot)
      return acc
    }, {})

    const racksToDisplay = selectedRackView
      ? [selectedRackView]
      : Object.keys(groupedByRack).length > 0
        ? [Object.keys(groupedByRack).sort()[0]]
        : []

    return (
      <div className="mt-4">
        {racksToDisplay.map((rackName) => {
          const rackSlots = groupedByRack[rackName]
          if (!rackSlots) return null
          const groupedByLevel = rackSlots.reduce((acc, slot) => {
            if (!acc[slot.level_code]) acc[slot.level_code] = []
            acc[slot.level_code].push(slot)
            return acc
          }, {})
          const levels = Object.keys(groupedByLevel).sort(
            (a, b) => parseInt(b) - parseInt(a)
          )

          return (
            <div key={rackName} className="mb-4 table-responsive">
              <h6 className="fw-bold fs-6">{rackName}</h6>
              <table className="table table-bordered text-center table-sm small">
                <tbody>
                  {levels.map((level, levelIndex) => {
                    const isTopLevel = levelIndex === 0
                    const isBottomLevel = levelIndex === levels.length - 1
                    const pairs = {}
                    groupedByLevel[level].forEach((slot) => {
                      const parts = slot.code.split('.')
                      const suffix = parts.pop()
                      const prefix = parts.join('.')
                      if (!pairs[prefix]) pairs[prefix] = {}
                      pairs[prefix][suffix] = slot
                    })

                    return (
                      <tr key={level}>
                        <td
                          className="align-middle fw-bold bg-light"
                          style={{ width: '8%', fontSize: '11px' }}
                        >
                          Level {level}
                        </td>
                        {Object.keys(pairs)
                          .sort()
                          .map((prefix) => {
                            const front = pairs[prefix]['F']
                            const rear = pairs[prefix]['R']
                            return (
                              <td key={prefix} className="p-0">
                                <div
                                  className="d-flex flex-column h-100"
                                  style={{ fontSize: '11px' }}
                                >
                                  {isTopLevel &&
                                    rear?.beam_code &&
                                    rear?.is_active !== false && (
                                      <div
                                        className="p-1 bg-warning text-dark fw-bold border-bottom"
                                        style={{ fontSize: '9px' }}
                                      >
                                        Beam: {rear.beam_code}
                                      </div>
                                    )}
                                  <div
                                    className="p-1 border-bottom"
                                    style={{
                                      backgroundColor:
                                        rear?.status === 'empty'
                                          ? '#B4C6E7'
                                          : rear
                                            ? '#C12727'
                                            : '',
                                      color:
                                        rear?.status === 'empty'
                                          ? '#000'
                                          : rear
                                            ? '#fff'
                                            : '',
                                      cursor:
                                        rear && step === 1
                                          ? 'pointer'
                                          : 'default'
                                    }}
                                    onClick={() => {
                                      if (rear && step === 1) {
                                        handleSelectLevel(rear.level_code)
                                        setShowModalUpdate(true)
                                        setShowDataMap(rear.id)
                                      }
                                    }}
                                  >
                                    {rear ? rear.code : `${prefix}.R`}
                                  </div>
                                  <div
                                    className="p-1"
                                    style={{
                                      backgroundColor:
                                        front?.status === 'empty'
                                          ? '#B4C6E7'
                                          : front
                                            ? '#C12727'
                                            : '',
                                      color:
                                        front?.status === 'empty'
                                          ? '#000'
                                          : front
                                            ? '#fff'
                                            : '',
                                      cursor:
                                        front && step === 1
                                          ? 'pointer'
                                          : 'default'
                                    }}
                                    onClick={() => {
                                      if (front && step === 1) {
                                        handleSelectLevel(front.level_code)
                                        setShowModalUpdate(true)
                                        setShowDataMap(front.id)
                                      }
                                    }}
                                  >
                                    {front ? front.code : `${prefix}.F`}
                                  </div>
                                  {isBottomLevel &&
                                    front?.beam_code &&
                                    front?.is_active !== false && (
                                      <div
                                        className="p-1 bg-warning text-dark fw-bold border-top"
                                        style={{ fontSize: '9px' }}
                                      >
                                        Beam: {front.beam_code}
                                      </div>
                                    )}
                                </div>
                              </td>
                            )
                          })}
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className="d-flex flex-row gap-3">
        <ArrowLeftCircle
          size={24}
          style={{ cursor: 'pointer' }}
          className="mt-1"
          onClick={() =>
            !step
              ? resetDetailData()
              : Common.showPopUpConfirmation(
                  'Leave Page?',
                  'Continue Updating',
                  'Discard Change and Leave Page',
                  resetDetailData
                )
          }
        />
        <h5 className="fw-bold ml-3" style={{ marginTop: '.2rem' }}>
          Map Editor ({data.warehouse_name})
        </h5>
      </div>

      <div className="row mt-4">
        <div className="col-8">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            <Tab eventKey="top-view" title="Top View">
              <div className="card">
                <div className="card-body card-map-pnp">
                  <div className="leaflet-map-container">
                    <MapContainer
                      center={[500, 500]}
                      zoom={1}
                      crs={L.CRS.Simple}
                      scrollWheelZoom={false}
                      style={{ height: '100%', width: '100%' }}
                    >
                      {step === 1 &&
                        [
                          Number('1'),
                          'ground',
                          'staging-area',
                          'vas',
                          'vas_pharma',
                          'transit_vas',
                          'transit_vas_pharma'
                        ].includes(selectLevel) && (
                          <FeatureGroup>
                            <EditControl
                              position="topright"
                              onCreated={_created}
                              onEdited={_edited}
                              onDeleted={_deleted}
                              draw={{
                                rectangle: {
                                  showArea: false
                                },
                                polyline: false,
                                polygon: false,
                                circle: false,
                                circlemarker: false,
                                marker: false
                              }}
                            />
                          </FeatureGroup>
                        )}
                      {file && (
                        <ImageOverlay
                          bounds={[
                            [0, 0],
                            [1000, 1000]
                          ]}
                          url={file}
                        />
                      )}
                      {dataMapEditor &&
                        dataMapEditor.length > 0 &&
                        dataMapEditor.map((value, index) => (
                          <Rectangle
                            bounds={value.coordinate}
                            eventHandlers={{
                              click: (e) => {
                                handleRectangleClick(value.id, value)
                              }
                            }}
                            color="transparent"
                            fillColor={
                              value.status === 'empty' ? '#B4C6E7' : '#C12727'
                            }
                            fillOpacity={0.5}
                            key={value.id}
                          ></Rectangle>
                        ))}
                    </MapContainer>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="side-view" title="Side View">
              <div className="card">
                <div className="card-body">{renderSideView()}</div>
              </div>
            </Tab>
          </Tabs>
        </div>
        <div className="col-4">
          {activeTab === 'top-view' ? (
            dataMapEditor?.filter((mapEditor) => mapEditor.status === 'full')
              .length > 0 || step === 1 ? (
              <>
                <ListGroup>
                  <ListGroup.Item
                    className="p-3"
                    disabled={true}
                    style={{ backgroundColor: '#F1F2F7' }}
                  >
                    Level
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('staging-area')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Staging Area</span>
                      </div>
                      {selectLevel === 'staging-area' && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('vas')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Area VAS</span>
                      </div>
                      {selectLevel === 'vas' && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('vas_pharma')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Area VAS Pharma</span>
                      </div>
                      {selectLevel === 'vas_pharma' && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('transit_vas')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Area Transit VAS</span>
                      </div>
                      {selectLevel === 'transit_vas' && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('transit_vas_pharma')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Area Transit VAS Pharma</span>
                      </div>
                      {selectLevel === 'transit_vas_pharma' && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('ground')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Ground</span>
                      </div>
                      {selectLevel === 'ground' && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('1')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 1</span>
                      </div>
                      {selectLevel === 1 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('2')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 2</span>
                      </div>
                      {selectLevel === 2 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('3')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 3</span>
                      </div>
                      {selectLevel === 3 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('4')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 4</span>
                      </div>
                      {selectLevel === 4 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('5')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 5</span>
                      </div>
                      {selectLevel === 5 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('6')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 6</span>
                      </div>
                      {selectLevel === 6 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('7')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 7</span>
                      </div>
                      {selectLevel === 7 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('8')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 8</span>
                      </div>
                      {selectLevel === 8 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('9')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 9</span>
                      </div>
                      {selectLevel === 10 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item
                    className="p-3"
                    onClick={(e) => handleSelectLevel('10')}
                  >
                    <div className="row">
                      <div className="col-10">
                        <span>Level 10</span>
                      </div>
                      {selectLevel === 10 && (
                        <div className="col-2">
                          <Check size={18} />
                        </div>
                      )}
                    </div>
                  </ListGroup.Item>
                </ListGroup>
              </>
            ) : (
              <>
                <button
                  className="btn btn-primary-orange d-block w-100 fw-bold"
                  onClick={() => onHandleStep(1)}
                >
                  Continue
                </button>
                <button
                  className="btn btn-outline-secondary mt-2 w-100 fw-bold"
                  onClick={handleClick}
                >
                  Change Image
                </button>
                <input
                  type="file"
                  name="change_image"
                  id="change_image"
                  accept="image/*"
                  className="d-none"
                  onChange={handleChange}
                  ref={hiddenFileInput}
                />
              </>
            )
          ) : (
            <div className="card">
              <div className="card-body">
                <h6 className="fw-bold mb-3">Filter Rack</h6>
                <Select
                  options={[...new Set(doubleRackSlots.map((s) => s.rack_name))]
                    .sort()
                    .map((rackName) => ({ value: rackName, label: rackName }))}
                  value={{
                    value:
                      selectedRackView ||
                      Object.keys(
                        doubleRackSlots.reduce((acc, slot) => {
                          if (!acc[slot.rack_name]) acc[slot.rack_name] = []
                          acc[slot.rack_name].push(slot)
                          return acc
                        }, {})
                      ).sort()[0] ||
                      '',
                    label:
                      selectedRackView ||
                      Object.keys(
                        doubleRackSlots.reduce((acc, slot) => {
                          if (!acc[slot.rack_name]) acc[slot.rack_name] = []
                          acc[slot.rack_name].push(slot)
                          return acc
                        }, {})
                      ).sort()[0] ||
                      ''
                  }}
                  onChange={(selectedOption) =>
                    setSelectedRackView(
                      selectedOption ? selectedOption.value : ''
                    )
                  }
                  filterOption={(option, inputValue) => {
                    const trimmedInput = inputValue.trim().toLowerCase()
                    return option.label.toLowerCase().includes(trimmedInput)
                  }}
                  isClearable={false}
                  isSearchable={true}
                  placeholder="Search rack..."
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <ModalMapEditor
        show={showModalAdd}
        onHide={() => {
          setShowModalAdd(false)
          document
            .querySelector(".leaflet-interactive[stroke='#3388ff']")
            ?.remove()
        }}
        rectangleBoundValue={rectangleBounds}
        selectLevel={selectLevel}
        warehouseId={data.id}
        onHandleListMapEditor={() => listMapEditor(selectLevel, data.id)}
      />

      <ModalUpdateMapEditor
        show={showModalUpdate}
        onHide={() => setShowModalUpdate(false)}
        onSelectlevel={selectLevel}
        dataShowMap={showDataMap}
        warehouseId={data.id}
        onHandleListMapEditor={() => listMapEditor(selectLevel, data.id)}
      />

      <ModalMapVas
        show={showModalVas}
        onHide={() => setShowModalVas(false)}
        selectLevel={selectLevel}
        handleSubmitMapVas={handleSubmitMapVas}
        loadingMapVas={loadingMapVas}
        showDataMap={showDataMap}
        setShowDataMap={setShowDataMap}
        onHandleListMapEditor={() => listMapEditor(selectLevel, data.id)}
      />
    </>
  )
}
export default MapEditorDetail
